

















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Contact extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  private backend!: string;

  public mounted() {
    // TODO: Load Recaptcha JS automatically
    const http = new XMLHttpRequest();
    http.onreadystatechange = () => {
      if (http.readyState === XMLHttpRequest.DONE) {
        if (http.status === 200) {
          const config = JSON.parse(http.responseText);
          this.renderCaptcha(config);
        }
      }
    };
    http.open('GET', this.backend + '/captcha', true);
    http.send();

    if (window.location.hash === '#success') {
      this.showToast(
        'Ihre Nachricht wurde erfolgreich übermittelt!',
        'success',
      );
    } else if (window.location.hash === '#error') {
      this.showToast(
        'Ihre Nachricht konnte nicht übermittelt werden!',
        'error',
      );
    }
  }

  public showToast(message: string, type: string) {
    history.replaceState(
      '',
      document.title,
      window.location.pathname + window.location.search,
    );
    this.$nextTick(() => {
      const elem = document.getElementById('kontakt');
      if (elem == null) {
        return;
      }
      elem.scrollIntoView();
    });

    return Vue.toasted.show(message, {
      theme: 'bubble',
      position: 'bottom-center',
      type,
      duration: 3000,
    });
  }

  public renderCaptcha(config: any) {
    if (!grecaptcha || !grecaptcha.render) {
      setTimeout(() => this.renderCaptcha(config), 100);
    } else {
      grecaptcha.render('g-recaptcha', {
        sitekey: config.site,
      });
    }
  }
}

(() => {
  'use strict';
  window.addEventListener(
    'load',
    () => {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.getElementsByClassName('needs-validation');
      // Loop over them and prevent submission
      const validation = Array.prototype.filter.call(forms, (form: any) => {
        form.addEventListener(
          'submit',
          (event: any) => {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add('was-validated');
          },
          false,
        );
      });
    },
    false,
  );
})();
